<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Individuazione zone</span>
</div>

<div class="step-fields step-fields--half">
  @if (flow.oilZones().length > 0) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Zona OIL</mat-label>
      <mat-select placeholder="Seleziona" [value]="flow.zoneOil()?.value ?? null" (selectionChange)="selectOil($event.value)">
        @for (zone of flow.oilZones(); track zone.value) {
          <mat-option [value]="zone.value">{{ zone.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (flow.nonOilZones().length > 0) {
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Zona NON OIL</mat-label>
      <mat-select placeholder="Seleziona" [value]="flow.zoneNonOil()?.value ?? null" (selectionChange)="selectNonOil($event.value)">
        @for (zone of flow.nonOilZones(); track zone.value) {
          <mat-option [value]="zone.value">{{ zone.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>

@if (flow.outOfZone()) {
  <ord-new-customer-banner
    type="warning"
    title="Cliente fuori zona di competenza"
    message="L'assegnazione di questo cliente richiede l'autorizzazione preventiva da parte del Procuratore d'Area di riferimento."
  />
}

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!flow.hasZone()" (click)="continue()">
    {{ flow.outOfZone() ? 'Richiedi autorizzazione' : 'Prosegui' }}
  </button>
</div>
